module.exports = true;


//////////////////
// WEBPACK FOOTER
// D:/midea_porject/php/htdocs/~/core-js/library/modules/$.library.js
// module id = 19
// module chunks = 0